import { CancelledError } from 'src/core/classes/error/CancelledError'
import Logger from 'src/core/utils/Logger'

import { IRestRequestArgs } from '../models/IRestRequestArgs'

import { HttpHeaders } from './HttpHeaders'
import { HttpRequest } from './HttpRequest'

export class Rest {
  public static async get(data: IRestRequestArgs): Promise<any> {
    return Rest.request('get', data)
  }

  public static async post(data: IRestRequestArgs): Promise<any> {
    return Rest.request('post', data)
  }

  public static async put(data: IRestRequestArgs): Promise<any> {
    return Rest.request('put', data)
  }

  public static async delete(data: IRestRequestArgs): Promise<any> {
    return Rest.request('delete', data)
  }

  private static async request(
    method: 'get' | 'post' | 'put' | 'delete',
    {
      url,
      payload = {},
      cancelObject,
      headers,
      force = false,
      signal,
      onUploadProgress,
      identityToken,
    }: IRestRequestArgs
  ): Promise<any> {
    let httpHeader: HttpHeaders | undefined = headers

    if (!headers) {
      httpHeader = new HttpHeaders()
      httpHeader.add('Content-Type', 'application/json; charset=UTF-8')
    }

    if (httpHeader) {
      const request = new HttpRequest(httpHeader)
      const response = await request[method]({
        url,
        payload,
        cancelObject,
        force,
        signal,
        onUploadProgress,
        identityToken,
      }).catch(Logger.error)
      if (response?.cancelled) {
        throw new CancelledError('Request was cancelled')
      }
      const responseData = response && response['data'] ? response['data'] : null
      if (responseData && responseData['Errors']) {
        // Preserve the HTTP status on the thrown error so callers can react to it
        // (e.g. treat an idempotent 404/410 as success). The message stays first,
        // so existing `error.message` consumers are unaffected.
        const restError = new Error(responseData['Errors']) as Error & {
          status?: number
          responseBody?: unknown
        }
        const status = response['status']
        if (typeof status === 'number') {
          Object.assign(restError, { status })
        }
        if (response['responseBody'] !== undefined) {
          Object.assign(restError, { responseBody: response['responseBody'] })
        }
        throw restError
      }
      return responseData
    }

    return null
  }
}
